import { optionalString, requireObject } from './parse.js';

/**
 * Mirrors com.medprompt.document.details.Person
 *
 * @typedef {object} PersonData
 * @property {string|null} name
 * @property {string|null} phoneNumber
 * @property {string|null} email
 * @property {string|null} organisation
 * @property {string|null} address
 * @property {string|null} specialty
 */

/**
 * @param {object} raw
 * @returns {PersonData}
 */
export function fromPersonData(raw) {
  const source = requireObject(raw, 'Person');
  return {
    name: optionalString(source.name),
    phoneNumber: optionalString(source.phoneNumber),
    email: optionalString(source.email),
    organisation: optionalString(source.organisation),
    address: optionalString(source.address),
    specialty: optionalString(source.specialty),
  };
}
